import React from 'react';

import { Badge, Button, Divider, Group, Modal, Stack, Text, Title } from '@mantine/core';
import { WorkoutMovementList } from 'types';
import { SCORE_TYPE_LABEL_MAP, ScoreTypeEnum } from 'types/enums';

interface IModalMovementViewProps {
  opened: boolean;
  closeHandler: () => void;
  movement?: WorkoutMovementList;
  onEdit?: () => void;
  permission?: boolean;
}

const ModalMovementView = ({
  opened,
  closeHandler,
  movement,
  onEdit,
  permission = true,
}: IModalMovementViewProps): JSX.Element => {
  if (!movement) return <></>;

  const isDefault = movement.source === 'Default';

  return (
    <Modal
      centered
      opened={opened}
      onClose={closeHandler}
      title={<Title order={4}>{movement.name}</Title>}
      size='md'
    >
      <Divider mb='lg' />
      <Stack spacing='lg'>
        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Movement Name
          </Text>
          <Text size='md' mt={4}>
            {movement.name}
          </Text>
        </div>

        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Description
          </Text>
          {movement.description ? (
            <Text size='md' mt={4}>
              {movement.description}
            </Text>
          ) : (
            <Text size='sm' color='dimmed' mt={4} italic>
              No description provided
            </Text>
          )}
        </div>

        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Default Score Type
          </Text>
          {movement.defaultScoreType ? (
            <Text size='md' mt={4}>
              {SCORE_TYPE_LABEL_MAP[movement.defaultScoreType as ScoreTypeEnum]}
            </Text>
          ) : (
            <Text size='sm' color='dimmed' mt={4} italic>
              Not set
            </Text>
          )}
        </div>

        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Source
          </Text>
          <Badge color={isDefault ? 'blue' : 'gray'} variant='filled' size='lg' mt={4}>
            {movement.source}
          </Badge>
        </div>

        <Group position='right' mt='md'>
          <Button variant='subtle' onClick={closeHandler}>
            Close
          </Button>
          {onEdit && (
            <Button onClick={onEdit} disabled={!permission}>
              Edit
            </Button>
          )}
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalMovementView;
